import type { FallbackProps } from 'react-error-boundary'
import {
  errorDetails,
  errorDetailsCode,
  errorDetailsSummary
} from './ErrorDetails.css'

export const ErrorDetails = ({ error }: { error: FallbackProps['error'] }) => {
  return (
    <details className={errorDetails}>
      <summary className={errorDetailsSummary}>Détails de l'erreur</summary>
      <code className={errorDetailsCode}>
        {error instanceof Error ? error.message : String(error)}
      </code>
    </details>
  )
}
